export function setDate(value) {
    return {
        type: 'SET_DATE_FILTER',
        value
    }
}


// WEBPACK FOOTER //
// ./src/actions/dateFilter.js